import { render } from "./ManifestoDetails.vue?vue&type=template&id=eb3e1e42&scoped=true"
import script from "./ManifestoDetails.vue?vue&type=script&lang=js"
export * from "./ManifestoDetails.vue?vue&type=script&lang=js"

import "./ManifestoDetails.vue?vue&type=style&index=0&id=eb3e1e42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb3e1e42"]])

export default __exports__